import { RootActionTypes, ThunkResult } from '../../../stores/types';
import ActionTypes from '../constants/ActionTypes';
import formatErrorResponseV2, { FormattedErrorMessages } from '../../../utilities/format-error-response-v2';

function fetchDiscountRequestAction(): RootActionTypes {
  return {
    type: ActionTypes.FETCH_DISCOUNT_REQUEST,
  };
}

function fetchDiscountSuccessAction(
  payload: io.flow.v0.models.DiscountRuleSettings,
): RootActionTypes {
  return {
    type: ActionTypes.FETCH_DISCOUNT_SUCCESS,
    payload,
  };
}

function fetchDiscountFailureAction(payload: FormattedErrorMessages): RootActionTypes {
  return {
    type: ActionTypes.FETCH_DISCOUNT_FAILURE,
    error: true,
    payload,
  };
}

export default function fetchDiscount(
  organization: string,
  id: string,
): ThunkResult<Promise<void>> {
  return function fetchDiscountEffects(
    dispatch,
    getState,
    extra,
  ): Promise<void> {
    const state = getState();
    dispatch(fetchDiscountRequestAction());

    return extra.api(state).discountRuleSettings.get({
      organization,
      id: [id],
    }).then((response) => {
      if (response.ok) {
        dispatch(fetchDiscountSuccessAction(response.body[0]));
        return;
      }

      dispatch(fetchDiscountFailureAction(formatErrorResponseV2(response)));
    });
  };
}
